import { IntegrationPayload } from "containers/integration/types";
import { SchoolPayload } from "models";
import { Client } from "./config";

export function FetchIntegration(year_id: string, class_id: string) {
  return Client.get<IntegrationPayload>(
    `/data/third_graph?year_id=${year_id}&class_id=${class_id}`
  );
}

export function FetchIntegrationDropdown(school_id: string) {
  return Client.get<SchoolPayload>(
    `/data/getThirdGraphClassDropdown?schoolID=${school_id}`
  );
}
